// biome-ignore lint/style/noRestrictedImports: component usage
import { Content } from "@radix-ui/react-tabs";
import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_tabs.module.css";

export type TabsContentProps = React.ComponentPropsWithoutRef<typeof Content>;

export const TabsContent = React.forwardRef<React.ElementRef<typeof Content>, TabsContentProps>(
	({ className, ...props }, ref) => (
		<Content
			className={cx(styles.content, className)}
			ref={ref}
			// radix assigns tabIndex={0} by default, which makes sense in less common cases
			tabIndex={undefined}
			{...props}
		/>
	),
);

if (import.meta.env.DEV) {
	TabsContent.displayName = Content.displayName;
}
